// extracted by mini-css-extract-plugin
var _1 = "loandetails_arrow__2oqiy";
var _2 = "loandetails_arrowwrapper__ydmec";
var _3 = "#4c4c4c";
var _4 = "loandetails_button__hugjw";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "loandetails_desktoptext__mj-xi";
var _9 = "loandetails_detailstext__zou8-";
var _a = "loandetails_down__rtolh";
var _b = "#434343";
var _c = "loandetails_icon__ufpm6";
var _d = "loandetails_label__suv4c";
var _e = "79px";
var _f = "110px";
var _10 = "72px";
var _11 = "loandetails_mobiletext__p33ub";
var _12 = "665px";
var _13 = "loandetails_open__kh60w";
var _14 = "loandetails_personalize__syj1i";
var _15 = "loandetails_summary__thfps";
var _16 = "teal";
var _17 = "loandetails_text__kfotu";
var _18 = "2";
var _19 = "#cdd3dc";
var _1a = "loandetails_up__zgycu";
var _1b = "loandetails_value__vzvpf";
var _1c = "loandetails_wrapper__0mnz4";
export { _1 as "arrow", _2 as "arrowWrapper", _3 as "body", _4 as "button", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "desktopText", _9 as "detailsText", _a as "down", _b as "headline", _c as "icon", _d as "label", _e as "menuHeight", _f as "menuHeightLarge", _10 as "menuHeightMobile", _11 as "mobileText", _12 as "modalMobileWidth", _13 as "open", _14 as "personalize", _15 as "summary", _16 as "teal", _17 as "text", _18 as "timelineStrokeWidth", _19 as "timelineTrackColor", _1a as "up", _1b as "value", _1c as "wrapper" }
